import { defineComponent as _defineComponent } from 'vue'
import { BeneficiaryStatus, Beneficiary } from 'ah-api-gateways';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';
import capitalize from 'lodash/capitalize';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BeneficiaryDetails',
  props: {
    beneficiary: null,
    addAccount: { type: Boolean, default: false },
    addBankAllowed: { type: [Boolean, String], default: true },
    removeBankAllowed: { type: [Boolean, String], default: true }
  },
  setup(__props: any) {

const props = __props as { beneficiary: Beneficiary, addAccount: boolean, addBankAllowed: boolean | string, removeBankAllowed: boolean | string };



const beneficiaryTypeText = computed(() => {
  if (props.beneficiary) {
    return capitalize(props.beneficiary.type);
  }
  return '';
});

const beneficiaryStatusText = computed(() => {
  if (props.beneficiary) {
    return capitalize(props.beneficiary.status);
  }
  return '';
});

return { __sfc: true,props, beneficiaryTypeText, beneficiaryStatusText, BeneficiaryStatus, countryNameFromCC }
}

})